import dayjs from 'dayjs';
import React from 'react';
import {Money} from '../../../components';

const getLabel = (field, quote) => {
  switch (field) {
    case 'user_id': return 'Assigned to';
    case 'reviewer_id': return 'Reviewer';
    case 'counter_price': return `${quote?.type === 'sell' ? 'Buying' : 'Selling'} Price`;
    case 'counter_currency': return `${quote?.type === 'sell' ? 'Buying' : 'Selling'} Currency`;
    default: return field.replace(/_/g, ' ').replace(/\b\w/g, l => l.toUpperCase());
  }
}

const getOldValue = (change) => {
  if (!change) {
    return null;
  }

  if (['price', 'min_price', 'max_price', 'counter_price'].includes(change.field)) {
    return <Money amount={change.old} currency={change.old_currency} />;
  }

  let value = change.old_label || change.old;

  return change.field === 'status' ? value.replace(/_/g, ' ') : (
    typeof value === 'object' ? JSON.stringify(value) : value
  );
}

const getNewValue = (change) => {
  if (!change) {
    return null;
  }

  if (['price', 'min_price', 'max_price', 'counter_price'].includes(change.field)) {
    return <Money amount={change.new} currency={change.new_currency} />;
  }

  let value = change.new_label || change.new;

  return change.field === 'status' ? value.replace(/_/g, ' ') : (
    typeof value === 'object' ? JSON.stringify(value) : value
  );
}

const Item = ({ item, quote }) => {
  const changes = item.changes.filter((change) => change.old || change.new);

  return (
    <div className="updates__entry">
      <div className="updates__meta">
        <span className="updates__date">{dayjs(item.date).format('DD/MM/YYYY - HH:mm')}</span>
        <span className="updates__admin">{item.user?.first_name} {item.user?.last_name}</span>
      </div>

      {changes.length > 0 && (
        <div className="updates__changes">
          {changes.map((change) => (
            <span className="updates__change" key={change.field}>
              <strong>{getLabel(change.field, quote)}</strong>:&nbsp;
              {getOldValue(change, quote)} → {getNewValue(change, quote)}
            </span>
          ))}
        </div>
      )}
    </div>
  );
};

const Updates = ({ quote }) => {
  const data = quote?.history;

  if (!data || data.length === 0) {
    return null;
  }

  let parsed;
  try {
    parsed = typeof data === 'string' ? JSON.parse(data) : data;
  } catch (_) {
    parsed = []; // bad/non-JSON string — render nothing
  }

  const updates = (Array.isArray(parsed) ? parsed : [])
    .filter((item) => item.changes?.filter(change => change.old || change.new).length > 0);

  if (updates.length === 0) {
    return null;
  }

  return (
    <div className="updates">
      <div className="updates__section-label">Last update</div>
      <Item item={updates[0]} quote={quote} />

      {updates.length > 1 && (
        <>
          <div className="updates__section-label">Other updates</div>
          <div className="updates__list">
            {updates.slice(1).map((item) => (
              <Item key={item.date} item={item} quote={quote} />
            ))}
          </div>
        </>
      )}
    </div>
  );
}

export default Updates;
